import editAddressModalMobileReducer from './slice';

export default editAddressModalMobileReducer;

export * from './data';
export * from './selectors';
export * from './slice';
export * from './types';
